import {Component} from "@angular/core";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MatDialogRef} from "@angular/material/dialog";
import {i18nService} from "src/app/service-utils/i18n.service";
import {PasswordsApiService} from "../../../api/passwords-api.service";
import {PasswordRecoveryRequest} from "../../../auth/auth.model";
import {Router} from "@angular/router";
import {usernameValidator} from "../../validation/validators";
import {MessageService} from "../../message/message.service";

@Component({
  selector: 'app-password-recovery-dialog',
  templateUrl: './password-recovery-dialog.component.html',
  styleUrls: ['./password-recovery-dialog.component.scss']
})
export class PasswordRecoveryDialogComponent {

  form: FormGroup;
  showError: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<PasswordRecoveryDialogComponent>,
    public i18nService: i18nService,
    private formBuilder: FormBuilder,
    private passwordsApi: PasswordsApiService,
    private message: MessageService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      customerNumber: new FormControl([], Validators.required),
      username: new FormControl([], [Validators.required, usernameValidator])
    });
  }

  recovery() {
    if (this.form.valid) {
      let data: PasswordRecoveryRequest = {...this.form.value};
      this.passwordsApi.recover(data).subscribe(response => {
        if (response.success) {
          this.message.info("password.recovery.success");
          this.dialogRef.close();
        } else {
          this.showError = true;
        }
      });
    }
  }
}
